import { getRootFontSize } from './utils'

let resizeFrameId = 0

const updateRootFontSize = () => {
  const size = getRootFontSize(window.innerWidth)
  document.documentElement.style.fontSize = `${size}px`
}

// resize 高频触发时只在下一帧真正写入一次根字号，
// 避免窗口拖动过程中连续改写 documentElement.style.fontSize。
const scheduleUpdateRootFontSize = () => {
  if (resizeFrameId) {
    return
  }

  resizeFrameId = window.requestAnimationFrame(() => {
    resizeFrameId = 0
    updateRootFontSize()
  })
}

updateRootFontSize()
window.addEventListener('resize', scheduleUpdateRootFontSize)
